// This file has helper functions for the auth components

import moment from "moment";

import type {Location} from "@repo/urls";

// isKhanmigoAuth returns true if the user is logging in or signing up for a
// Khanmigo-related purpose.
function isKhanmigoAuth(location: Location) {
    const {referral} = location.queryParams;
    return isKhanmigoReferral(referral);
}

// isKhanmigoReferral returns true if the referral is KhanmigoCheckout or
// KhanmigoSignup
function isKhanmigoReferral(referral: string) {
    return referral in {KhanmigoCheckout: true, KhanmigoSignup: true};
}

// isKhanmigoSignupLearnerParentSignup returns true if the user is
// signing up as a learner or parent and the referral is KhanmigoSignup
function isKhanmigoSignupLearnerParentSignup(
    role: string,
    referral?: string,
): boolean {
    return (
        (role === "parent" || role === "learner") &&
        referral === "KhanmigoSignup"
    );
}

// isKhanmigoSignupTeacherSignup returns true if the user is
// signing up as a learner or parent and the referral is KhanmigoSignup
function isKhanmigoSignupTeacherSignup(
    role: string,
    referral?: string,
): boolean {
    return role === "teacher" && referral === "KhanmigoSignup";
}

// isLearnStormReferral returns true if the referral is LearnStorm
function isLearnStormReferral(referral: string) {
    return referral === "LearnStorm";
}

function calculateAge(birthdate: string): number {
    return moment().diff(moment(birthdate, "YYYY-MM-DD"), "years");
}

export {
    isKhanmigoAuth,
    isKhanmigoReferral,
    isKhanmigoSignupLearnerParentSignup,
    isKhanmigoSignupTeacherSignup,
    isLearnStormReferral,
    calculateAge,
};
